"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportsStateContext = exports.reduceReports = exports.initialReportsState = exports.getDateRangeOptions = exports.dayDateRanges = exports.monthDateRanges = void 0;
const react_1 = __importDefault(require("react"));
const luxon_1 = require("luxon");
const utils_1 = require("./utils");
function getResetDefaultsForUpdate(prevState, update) {
    const resetDefaults = {};
    if (update.isOverTime !== undefined) { // it is set and is changing
        resetDefaults.chartType = update.isOverTime ? utils_1.ChartTypes.STACKED_BAR : utils_1.ChartTypes.PIE;
        resetDefaults.timeStep = (prevState.dateRange.value.count('days') <= 33 && prevState.tabName !== utils_1.Tabs.INCOME_VS_SPENDING) ? 'days' : 'months';
        resetDefaults.breadcrumbs = [];
    }
    return resetDefaults;
}
const lastMonthRange = luxon_1.Interval.fromDateTimes(luxon_1.DateTime.local().minus({ months: 1 }).startOf('month'), luxon_1.DateTime.local().startOf('month').minus({ seconds: 1 }));
const last3MonthsRange = luxon_1.Interval.fromDateTimes(luxon_1.DateTime.local().minus({ months: 2 }).startOf('month'), luxon_1.DateTime.local());
const last6MonthsRange = luxon_1.Interval.fromDateTimes(luxon_1.DateTime.local().minus({ months: 5 }).startOf('month'), luxon_1.DateTime.local());
const thisMonthRange = luxon_1.Interval.fromDateTimes(luxon_1.DateTime.local().startOf('month'), luxon_1.DateTime.local());
const thisYearRange = luxon_1.Interval.fromDateTimes(luxon_1.DateTime.local().startOf('year'), luxon_1.DateTime.local().endOf('day'));
const lastYearRange = luxon_1.Interval.fromDateTimes(luxon_1.DateTime.local().startOf('year').minus({ years: 1 }), luxon_1.DateTime.local().startOf('year').minus({ seconds: 1 }));
exports.monthDateRanges = [
    { label: 'Last 3 months', value: last3MonthsRange, id: 'date_range_last_3_months' },
    { label: 'Last 6 months', value: last6MonthsRange, id: 'date_range_last_6_months' },
    { label: 'Year to date', value: thisYearRange, id: 'date_range_this_year' },
    { label: 'Last year', value: lastYearRange, id: 'date_range_last_year' },
];
exports.dayDateRanges = [
    { label: 'This month', value: thisMonthRange, id: 'date_range_this_month' },
    { label: 'Last month', value: lastMonthRange, id: 'date_range_last_month' },
];
const allDateRanges = exports.dayDateRanges.concat(exports.monthDateRanges);
const defaultsByTabName = {
    [utils_1.Tabs.SPENDING]: { dateRange: allDateRanges[0], chartType: utils_1.ChartTypes.PIE, timeStep: 'days' },
    [utils_1.Tabs.NET_INCOME]: { dateRange: exports.monthDateRanges[1], chartType: utils_1.ChartTypes.GROUPED_BAR, timeStep: 'months' },
    [utils_1.Tabs.INCOME_VS_SPENDING]: { dateRange: exports.monthDateRanges[1], chartType: utils_1.ChartTypes.INCOME_VS_SPENDING, timeStep: 'months' },
};
function getResetDefaultsForTabChange(paramPrevState, { tabName }) {
    const prevState = paramPrevState;
    prevState.fallbackSelect.current = null;
    const resetDefaults = Object.assign(Object.assign({}, defaultsByTabName[tabName]), { tabName });
    resetDefaults.breadcrumbs = [];
    return resetDefaults;
}
function getResetDefaultsForInit({ tabName, layoutView }) {
    const resetDefaults = defaultsByTabName[tabName] ? Object.assign({}, defaultsByTabName[tabName]) : {};
    if (layoutView === 'over-time' && tabName === utils_1.Tabs.SPENDING) {
        resetDefaults.chartType = utils_1.ChartTypes.STACKED_BAR;
        resetDefaults.dateRange = exports.monthDateRanges[1];
        resetDefaults.timeStep = 'months';
    }
    else if (layoutView === 'total' && tabName === utils_1.Tabs.SPENDING) {
        resetDefaults.chartType = utils_1.ChartTypes.PIE;
        resetDefaults.timeStep = 'days';
        resetDefaults.dateRange = allDateRanges[0];
    }
    resetDefaults.tabName = tabName;
    resetDefaults.pageInitialized = true;
    return resetDefaults;
}
const getDateRangeOptions = (tabName) => {
    switch (tabName) {
        case utils_1.Tabs.SPENDING:
        case utils_1.Tabs.NET_INCOME:
            return allDateRanges;
        case utils_1.Tabs.INCOME_VS_SPENDING:
            return exports.monthDateRanges;
        default:
            return allDateRanges;
    }
};
exports.getDateRangeOptions = getDateRangeOptions;
exports.initialReportsState = {
    filterObject: null,
    dateRange: exports.monthDateRanges[1],
    timeStep: 'months',
    chartType: 'pie',
    breadcrumbs: [],
    pageInitialized: false,
    fallbackSelect: react_1.default.createRef(),
    breakdownIncomeVsExpense: utils_1.IncomeVsExpenseBreakdownTypes[0],
    selectedGraphCategory: '',
    selectedReportTableCell: '',
    visibleSectionIncomeVsExpense: '',
    clearGraphSelection: false,
};
function reduceReports(state, action) {
    switch (action.type) {
        case 'update':
            return Object.assign(Object.assign(Object.assign({}, state), action.payload), getResetDefaultsForUpdate(state, action.payload));
        case 'reset':
            return Object.assign({}, exports.initialReportsState);
        case 'init':
            return Object.assign(Object.assign({}, state), getResetDefaultsForInit(action.payload));
        case 'tabChange': // only happens if a tab button is clicked
            return Object.assign(Object.assign({}, state), getResetDefaultsForTabChange(state, action.payload));
        default:
            return state;
    }
}
exports.reduceReports = reduceReports;
const ReportsStateContext = react_1.default.createContext({});
exports.ReportsStateContext = ReportsStateContext;
ReportsStateContext.displayName = 'Reports State Context';
